export const PLAN_LIMITS = { free: 0, starter: 4, pro: 6 };

export const PLAN_FEATURES = {
  free:  { whatsapp: false, notion: false, schedule: false, presets: 1 },
  starter: { whatsapp: true, notion: false, schedule: true, presets: 0 },
  pro:   { whatsapp: true,  notion: true,  schedule: true,  presets: Infinity },
};
